import { defineMessages } from 'react-intl';

export const messages: {
	helperText: { defaultMessage: string; description: string; id: string };
	label: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	helperText: {
		id: 'edition-benefits-modal.shared.premium-trial-request-reason-messages.helperText',
		defaultMessage: 'Max 300 characters',
		description:
			'Helper text showing the maximum length of the optional Premium trial request reason.',
	},
	label: {
		id: 'edition-benefits-modal.shared.premium-trial-request-reason-messages.label',
		defaultMessage: 'Reason for request (optional)',
		description:
			'Label for an optional explanation sent to an administrator with a Premium trial request.',
	},
});
